import React from "react";
import PageContents from "../components/layouts/PageContents";
import UserProfileForm from "../components/projectusers/UserProfileForm";

const ProfilePage: React.FC = () => {
    return (
        <PageContents
            title="Profile"
            subtitle="Update your profile and contact information"
            isForbidden={false}
            variant="small"
            maxWidth="xs"
        >
            <UserProfileForm />
        </PageContents>
    );
};

export default ProfilePage;
